<section class="video-player-container">
  <vg-player
    id="vg-player"
    class="player"
    (onPlayerReady)="handlePlayerReadyEvent($event)"
  >
    <div
      class="video-overlay"
      [ngClass]="{
        'video-overlay-fade-in ': showVideoOverlay(),
        'video-overlay-fade-out ': !showVideoOverlay()
      }"
    >
      <div class="header">
        <p class="video-title">
          @if (isFullScreen()) {
            {{ video.title }}
          }
        </p>
      </div>
    </div>

    <vg-overlay-play></vg-overlay-play>
    <vg-buffering></vg-buffering>

    <vg-scrub-bar
      [ngClass]="{
        'video-overlay-fade-in ': showVideoOverlay(),
        'video-overlay-fade-out ': !showVideoOverlay()
      }"
    >
      <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
      <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
    </vg-scrub-bar>

    <vg-controls
      [ngClass]="{
        'video-overlay-fade-in ': showVideoOverlay(),
        'video-overlay-fade-out ': !showVideoOverlay()
      }"
    >
      <vg-play-pause></vg-play-pause>
      <div class="volume-controls">
        <vg-mute></vg-mute>
        <vg-volume></vg-volume>
      </div>
      <span>&nbsp;&nbsp;</span>
      <vg-time-display
        vgProperty="current"
        vgFormat="hh:mm:ss"
      ></vg-time-display>

      <span>&nbsp;&nbsp;</span>

      <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>

      <vg-playback-button
        [playbackValues]="['0.25', '0.5', '1', '1.5', '2', '4', '10']"
      ></vg-playback-button>
      <app-quality-control-selector
        [videoPlayerComponent]="this"
        [bindTo]="isFullScreen() ? vgOverlayPlay : 'body'"
        [isMouseHovering]="isMouseHovering"
      ></app-quality-control-selector>
      <vg-fullscreen></vg-fullscreen>
    </vg-controls>

    <video
      #media
      [vgMedia]="$any(media)"
      id="singleVideo"
      preload="auto"
      [autoplay]="true"
      [src]="selectedVideoSource?.url"
      crossorigin
    ></video>
  </vg-player>
</section>

<section class="video-metadata-container">
  <app-video-metadata
    [video]="video"
  >
    <div style="height: 12px" middle-content></div>
  </app-video-metadata>
</section>
